import { createIcon } from './IconPrimitive';

export const HorizontalOutputIcon = createIcon(
  'HorizontalOutputIcon',
  <path d="M20.701 3H3.871C2.84 3 2 3.842 2 4.87v11.22c0 1.03.842 1.871 1.87 1.871h6.546l-1.525 2.29a.932.932 0 0 0 .777 1.45h5.236c.748 0 1.197-.832.776-1.45l-1.524-2.29H20.7c1.029 0 1.87-.841 1.87-1.87V4.87c0-1.03-.841-1.871-1.87-1.871m0 11.22H3.871V5.806c0-.514.42-.935.934-.935h14.961c.515 0 .935.42.935.935z" />
);
